(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    

(function () {

  var STORAGE_KEY =
    'aceco_quote_customer_v1';


  function money(cents) {

    return new Intl.NumberFormat(
      'en-US',
      {
        style: 'currency',
        currency: 'USD'
      }
    ).format(
      Number(cents || 0) / 100
    );

  }


  function escapeHtml(value) {

    return String(
      value == null ? '' : value
    )
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  }


  function formatDate() {

    return new Date().toLocaleDateString(
      'en-US',
      {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      }
    );

  }


  function getCart() {

    return fetch(
      '/cart.js',
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then(function (response) {

        if (!response.ok) {
          throw new Error(
            'Unable to retrieve cart.'
          );
        }

        return response.json();

      });

  }


  /* ============================================================
     DISCOUNT CODE
     ============================================================ */

  function applyDiscountCode() {

    var input =
      document.getElementById(
        'aceco-discount-code'
      );

    var button =
      document.getElementById(
        'aceco-apply-discount'
      );


    if (!input) {
      return;
    }


    var code =
      (input.value || '').trim();


    if (!code) {

      input.focus();

      return;

    }


    if (button) {

      button.disabled =
        true;

      button.textContent =
        'Applying...';

    }


    var note =
      document.getElementById(
        'Cart-note'
      );


    var noteValue =
      note
        ? note.value
        : '';


    /*
      Save the current cart note first so the
      discount redirect does not lose an unsaved PO/note.
    */

    fetch(
      '/cart/update.js',
      {
        method: 'POST',

        credentials:
          'same-origin',

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json'
        },

        body:
          JSON.stringify({
            note: noteValue
          })
      }
    )

      .catch(
        function () {
        }
      )

      .then(
        function () {

          var discountUrl =

            '/discount/' +

            encodeURIComponent(
              code
            ) +

            '?redirect=' +

            encodeURIComponent(
              '/cart'
            );


          window.location.href =
            discountUrl;

        }
      );

  }


  function getThemeLogo() {

    var footer =
      document.getElementById(
        'main-cart-footer'
      );


    if (!footer) {
      return '';
    }


    return (
      footer.getAttribute(
        'data-aceco-logo'
      ) || ''
    );

  }


  function getCartNote() {

    var note =
      document.getElementById(
        'Cart-note'
      );


    if (
      note &&
      note.value &&
      note.value.trim()
    ) {

      return note.value.trim();

    }


    return '';

  }


  function getFieldValue(id) {

    var field =
      document.getElementById(id);


    if (!field) {
      return '';
    }


    return (
      field.value || ''
    ).trim();

  }


  function setFieldValue(
    id,
    value
  ) {

    var field =
      document.getElementById(id);


    if (field) {

      field.value =
        value || '';

    }

  }


  function getFormData() {

    return {

      company:
        getFieldValue(
          'aceco-company'
        ),

      contact:
        getFieldValue(
          'aceco-contact'
        ),

      address:
        getFieldValue(
          'aceco-address'
        ),

      address2:
        getFieldValue(
          'aceco-address2'
        ),

      cityStateZip:
        getFieldValue(
          'aceco-city-state-zip'
        ),

      phone:
        getFieldValue(
          'aceco-phone'
        ),

      email:
        getFieldValue(
          'aceco-email'
        ),

      projectPo:
        getFieldValue(
          'aceco-project-po'
        )

    };

  }


  function clearForm() {

    setFieldValue(
      'aceco-company',
      ''
    );

    setFieldValue(
      'aceco-contact',
      ''
    );

    setFieldValue(
      'aceco-address',
      ''
    );

    setFieldValue(
      'aceco-address2',
      ''
    );

    setFieldValue(
      'aceco-city-state-zip',
      ''
    );

    setFieldValue(
      'aceco-phone',
      ''
    );

    setFieldValue(
      'aceco-email',
      ''
    );

    setFieldValue(
      'aceco-project-po',
      ''
    );

  }


  function loadSavedInfo() {

    try {

      var raw =
        localStorage.getItem(
          STORAGE_KEY
        );


      if (!raw) {
        return;
      }


      var data =
        JSON.parse(raw);


      setFieldValue(
        'aceco-company',
        data.company ||
        data.company_name ||
        data.companyName ||
        ''
      );


      setFieldValue(
        'aceco-contact',
        data.contact ||
        data.contactName ||
        data.contact_name ||
        ''
      );


      setFieldValue(
        'aceco-address',
        data.address ||
        data.address1 ||
        ''
      );


      setFieldValue(
        'aceco-address2',
        data.address2 ||
        ''
      );


      var cityStateZip =
        data.cityStateZip ||
        data.city_state_zip ||
        '';


      if (
        !cityStateZip &&
        (
          data.city ||
          data.state ||
          data.zip
        )
      ) {

        cityStateZip = '';


        if (data.city) {
          cityStateZip +=
            data.city;
        }


        if (data.state) {

          if (cityStateZip) {
            cityStateZip += ', ';
          }


          cityStateZip +=
            data.state;

        }


        if (data.zip) {

          if (cityStateZip) {
            cityStateZip += ' ';
          }


          cityStateZip +=
            data.zip;

        }

      }


      setFieldValue(
        'aceco-city-state-zip',
        cityStateZip
      );


      setFieldValue(
        'aceco-phone',
        data.phone ||
        ''
      );


      setFieldValue(
        'aceco-email',
        data.email ||
        ''
      );


      setFieldValue(
        'aceco-project-po',
        data.projectPo ||
        data.project_po ||
        ''
      );


    } catch (error) {
    }

  }


  function saveFormData(data) {

    try {

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(data)
      );

    } catch (error) {
    }

  }


  function openModal() {

    var modal =
      document.getElementById(
        'aceco-quote-modal'
      );


    if (!modal) {
      return;
    }


    loadSavedInfo();


    var poField =
      document.getElementById(
        'aceco-project-po'
      );


    if (
      poField &&
      !poField.value.trim()
    ) {

      var cartNote =
        getCartNote();


      if (cartNote) {

        poField.value =
          cartNote;

      }

    }


    modal.hidden =
      false;


    modal.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      'aceco-modal-open'
    );

  }


  function closeModal() {

    var modal =
      document.getElementById(
        'aceco-quote-modal'
      );


    if (!modal) {
      return;
    }


    modal.hidden =
      true;


    modal.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      'aceco-modal-open'
    );

  }


  function normalizeImageUrl(url) {

    if (!url) {
      return '';
    }


    if (
      url.indexOf('//') === 0
    ) {

      return (
        'https:' +
        url
      );

    }


    return url;

  }


  function buildRows(cart) {

    var rows = '';


    cart.items.forEach(
      function (item) {

        var variant = '';


        if (
          item.variant_title &&
          item.variant_title !==
            'Default Title'
        ) {

          variant =

            '<div class="variant">' +

              escapeHtml(
                item.variant_title
              ) +

            '</div>';

        }


        var imageHtml = '';


        var imageUrl =
          normalizeImageUrl(
            item.image || ''
          );


        if (imageUrl) {

          imageHtml =

            '<img' +

              ' class="product-image"' +

              ' src="' +

                escapeHtml(
                  imageUrl
                ) +

              '"' +

              ' alt="' +

                escapeHtml(
                  item.product_title ||
                  item.title ||
                  ''
                ) +

              '"' +

            '>';

        }


        rows +=

          '<tr>' +


            '<td class="image-cell">' +

              imageHtml +

            '</td>' +


            '<td>' +

              '<strong>' +

                escapeHtml(
                  item.product_title ||
                  item.title
                ) +

              '</strong>' +

              variant +

            '</td>' +


            '<td>' +

              escapeHtml(
                item.sku || ''
              ) +

            '</td>' +


            '<td class="center">' +

              escapeHtml(
                item.quantity
              ) +

            '</td>' +


            '<td class="right">' +

              money(
                item.final_price
              ) +

            '</td>' +


            '<td class="right">' +

              money(
                item.final_line_price
              ) +

            '</td>' +


          '</tr>';

      }
    );


    return rows;

  }


  function buildPreparedFor(data) {

    if (!data) {
      return '';
    }


    var html = '';


    if (data.company) {

      html +=

        '<strong>' +

          escapeHtml(
            data.company
          ) +

        '</strong><br>';

    }


    if (data.contact) {

      html +=

        escapeHtml(
          data.contact
        ) +

        '<br>';

    }


    if (data.address) {

      html +=

        escapeHtml(
          data.address
        ) +

        '<br>';

    }


    if (data.address2) {

      html +=

        escapeHtml(
          data.address2
        ) +

        '<br>';

    }


    if (data.cityStateZip) {

      html +=

        escapeHtml(
          data.cityStateZip
        ) +

        '<br>';

    }


    if (data.phone) {

      html +=

        escapeHtml(
          data.phone
        ) +

        '<br>';

    }


    if (data.email) {

      html +=

        escapeHtml(
          data.email
        );

    }


    return html;

  }


  function buildPrintableCart(
    cart,
    customerData
  ) {

    var logoUrl =
      getThemeLogo();


    var rows =
      buildRows(cart);


    var preparedFor =
      buildPreparedFor(
        customerData
      );


    var projectPo = '';


    if (
      customerData &&
      customerData.projectPo
    ) {

      projectPo =
        customerData.projectPo;

    } else {

      projectPo =
        getCartNote();

    }


    var discountHtml = '';


    if (
      cart.total_discount > 0
    ) {

      discountHtml =

        '<div class="total-line">' +

          '<span>Discount</span>' +

          '<strong>-' +

            money(
              cart.total_discount
            ) +

          '</strong>' +

        '</div>';

    }


    var logoHtml = '';


    if (logoUrl) {

      logoHtml =

        '<img' +

          ' src="' +

          escapeHtml(
            logoUrl
          ) +

          '"' +

          ' alt="American Crane & Equipment Corporation"' +

          ' class="logo"' +

        '>';

    }


    var preparedForBox = '';


    if (preparedFor) {

      preparedForBox =

        '<div class="info-box">' +

          '<div class="info-label">' +

            'Prepared For' +

          '</div>' +

          preparedFor +

        '</div>';

    } else {

      preparedForBox =

        '<div class="info-box">' +

          '<div class="info-label">' +

            'Prepared For' +

          '</div>' +

          'Customer' +

        '</div>';

    }


    return [

      '<!doctype html>',

      '<html>',

      '<head>',

      '<title>ACECO Cart</title>',

      '<meta name="viewport" content="width=device-width,initial-scale=1">',

      '<style>',

      '@page{margin:.45in;}',

      '*{box-sizing:border-box;}',

      'body{font-family:Arial,Helvetica,sans-serif;color:#111;font-size:12px;margin:0;}',

      '.wrap{max-width:1000px;margin:0 auto;}',

      '.header{display:flex;justify-content:space-between;align-items:flex-start;gap:30px;padding-bottom:15px;border-bottom:3px solid #f7941d;}',

      '.brand{display:flex;align-items:flex-start;gap:14px;}',

      '.logo{display:block;max-width:165px;max-height:70px;width:auto;height:auto;object-fit:contain;}',

      '.company{font-size:20px;font-weight:700;line-height:1.15;}',

      '.department{font-size:12px;color:#555;margin-top:5px;}',

      '.date{font-size:11px;text-align:right;margin-top:4px;white-space:nowrap;}',

      '.info-grid{display:grid;grid-template-columns:1fr 1fr;gap:18px;margin:18px 0;}',

      '.info-box{border:1px solid #ddd;padding:12px;min-height:82px;line-height:1.5;}',

      '.info-label{font-size:10px;font-weight:700;text-transform:uppercase;color:#666;margin-bottom:6px;}',

      'table{width:100%;border-collapse:collapse;}',

      'thead{background:#f2f2f2;}',

      'th{font-size:10px;padding:8px 6px;border-bottom:2px solid #aaa;text-align:left;}',

      'td{padding:8px 6px;border-bottom:1px solid #ddd;vertical-align:middle;}',

      '.image-cell{width:72px;text-align:center;}',

      '.product-image{display:block;width:58px;height:58px;object-fit:contain;margin:0 auto;}',

      '.variant{font-size:10px;color:#666;margin-top:3px;}',

      '.center{text-align:center;}',

      '.right{text-align:right;white-space:nowrap;}',

      '.totals{width:330px;margin:18px 0 0 auto;}',

      '.total-line{display:flex;justify-content:space-between;gap:20px;padding:6px 0;}',

      '.grand-total{border-top:2px solid #111;font-size:18px;font-weight:700;padding-top:9px;}',

      '.fine-print{margin-top:22px;font-size:10px;color:#666;line-height:1.4;}',

      '.actions{text-align:center;margin-top:25px;}',

      '.print-button{background:#f7941d;color:#fff;border:0;border-radius:3px;padding:13px 28px;font-size:14px;font-weight:700;cursor:pointer;}',

      '@media print{.actions{display:none;}tr{break-inside:avoid;page-break-inside:avoid;}.product-image{print-color-adjust:exact;-webkit-print-color-adjust:exact;}}',

      '</style>',

      '</head>',

      '<body>',

      '<div class="wrap">',

      '<div class="header">',

      '<div class="brand">',

      logoHtml,

      '<div>',

      '<div class="company">American Crane &amp; Equipment Corporation</div>',

      '<div class="department">Parts Department</div>',

      '</div>',

      '</div>',

      '<div class="date">' +
        escapeHtml(formatDate()) +
      '</div>',

      '</div>',

      '<div class="info-grid">',

      preparedForBox,

      '<div class="info-box">',

      '<div class="info-label">Project / Purchase Order Reference</div>',

      projectPo
        ? '<strong>' +
          escapeHtml(projectPo) +
          '</strong>'
        : '—',

      '</div>',

      '</div>',

      '<table>',

      '<thead>',

      '<tr>',

      '<th style="width:8%;"></th>',

      '<th style="width:34%;">Item</th>',

      '<th style="width:16%;">SKU</th>',

      '<th style="width:8%;text-align:center;">Qty</th>',

      '<th style="width:16%;text-align:right;">Unit Price</th>',

      '<th style="width:18%;text-align:right;">Extended</th>',

      '</tr>',

      '</thead>',

      '<tbody>',

      rows,

      '</tbody>',

      '</table>',

      '<div class="totals">',

      '<div class="total-line">',

      '<span>Subtotal</span>',

      '<strong>' +
        money(
          cart.items_subtotal_price
        ) +
      '</strong>',

      '</div>',

      discountHtml,

      '<div class="total-line grand-total">',

      '<span>Cart Total</span>',

      '<span>' +
        money(
          cart.total_price
        ) +
      '</span>',

      '</div>',

      '</div>',

      '<div class="fine-print">',

      'Shipping and applicable taxes are not included unless specifically shown above. ',

      'Shipping will be calculated at checkout. ',

      'Pricing and availability are subject to change.',

      '</div>',

      '<div class="actions">',

      '<button class="print-button" onclick="window.print()">PRINT CART</button>',

      '</div>',

      '</div>',

      '</body>',

      '</html>'

    ].join('');

  }


  function printCart(
    customerData
  ) {

    var printWindow =
      window.open(
        '',
        'ACECO_PRINT_CART'
      );


    if (!printWindow) {

      alert(
        'Please allow pop-ups for this website and try again.'
      );

      return;

    }


    printWindow.document.open();


    printWindow.document.write(

      '<html>' +

      '<body style="' +
        'font-family:Arial,Helvetica,sans-serif;' +
        'padding:40px;' +
        'text-align:center;' +
      '">' +

      '<strong>' +
        'Creating your cart...' +
      '</strong>' +

      '</body>' +

      '</html>'

    );


    printWindow.document.close();


    getCart()

      .then(
        function (cart) {

          if (
            !cart.items ||
            !cart.items.length
          ) {

            printWindow.close();


            alert(
              'Your cart is empty.'
            );


            return;

          }


          printWindow.document.open();


          printWindow.document.write(

            buildPrintableCart(
              cart,
              customerData
            )

          );


          printWindow.document.close();

        }
      )

      .catch(
        function (error) {

          console.error(
            'ACECO Print Cart Error:',
            error
          );


          printWindow.close();


          alert(
            'We could not create the printable cart.'
          );

        }
      );

  }


  function buildShareUrl(cart) {

    var items = [];


    cart.items.forEach(
      function (item) {

        if (
          item.variant_id &&
          item.quantity
        ) {

          items.push(
            item.variant_id +
            ':' +
            item.quantity
          );

        }

      }
    );


    if (!items.length) {

      return (
        window.location.origin +
        '/cart'
      );

    }


    return (
      window.location.origin +
      '/cart/' +
      items.join(',')
    );

  }


  function buildShareText(
    cart,
    shareUrl
  ) {

    var lines = [];


    lines.push(
      'American Crane & Equipment Corporation'
    );


    lines.push(
      'Shopping Cart'
    );


    lines.push('');

    lines.push('');


    cart.items.forEach(
      function (item) {

        lines.push(
          item.product_title ||
          item.title
        );


        if (item.sku) {

          lines.push(
            'SKU: ' +
            item.sku
          );

        }


        lines.push(
          'Qty: ' +
          item.quantity
        );


        lines.push(
          'Unit Price: ' +
          money(
            item.final_price
          )
        );


        lines.push(
          'Extended: ' +
          money(
            item.final_line_price
          )
        );


        lines.push('');

      }
    );


    lines.push(
      'Cart Total: ' +
      money(
        cart.total_price
      )
    );


    lines.push('');


    lines.push(
      'Open Cart:'
    );


    lines.push(
      shareUrl
    );


    return lines.join('\n');

  }


  function setupAcecoCart() {

    var discountInput =
      document.getElementById(
        'aceco-discount-code'
      );


    var discountButton =
      document.getElementById(
        'aceco-apply-discount'
      );


    var printButton =
      document.getElementById(
        'aceco-print-cart'
      );


    var shareButton =
      document.getElementById(
        'aceco-share-cart'
      );


    var skipButton =
      document.getElementById(
        'aceco-skip-print'
      );


    var createButton =
      document.getElementById(
        'aceco-create-quote'
      );


    var clearButton =
      document.getElementById(
        'aceco-clear-saved'
      );


    var modal =
      document.getElementById(
        'aceco-quote-modal'
      );


    /* ==========================================================
       DISCOUNT EVENTS
       ========================================================== */

    if (discountButton) {

      discountButton.addEventListener(
        'click',
        function () {

          applyDiscountCode();

        }
      );

    }


    if (discountInput) {

      discountInput.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key ===
            'Enter'
          ) {

            event.preventDefault();

            applyDiscountCode();

          }

        }
      );

    }


    /* ==========================================================
       PRINT CART
       ========================================================== */

    if (printButton) {

      printButton.addEventListener(
        'click',
        function () {

          openModal();

        }
      );

    }


    if (skipButton) {

      skipButton.addEventListener(
        'click',
        function () {

          closeModal();

          printCart(null);

        }
      );

    }


    if (createButton) {

      createButton.addEventListener(
        'click',
        function () {

          var data =
            getFormData();


          saveFormData(data);


          closeModal();


          printCart(data);

        }
      );

    }


    if (clearButton) {

      clearButton.addEventListener(
        'click',
        function () {

          try {

            localStorage.removeItem(
              STORAGE_KEY
            );

          } catch (error) {
          }


          clearForm();


          var cartNote =
            getCartNote();


          if (cartNote) {

            setFieldValue(
              'aceco-project-po',
              cartNote
            );

          }

        }
      );

    }


    if (modal) {

      var closeControls =
        modal.querySelectorAll(
          '[data-aceco-close-modal]'
        );


      closeControls.forEach(
        function (control) {

          control.addEventListener(
            'click',
            closeModal
          );

        }
      );

    }


    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key ===
          'Escape'
        ) {

          if (
            modal &&
            !modal.hidden
          ) {

            closeModal();

          }

        }

      }
    );


    /* ==========================================================
       SHARE CART
       ========================================================== */

    if (shareButton) {

      shareButton.addEventListener(
        'click',
        function () {

          getCart()

            .then(
              function (cart) {

                if (
                  !cart.items ||
                  !cart.items.length
                ) {

                  alert(
                    'Your cart is empty.'
                  );


                  return;

                }


                var shareUrl =
                  buildShareUrl(
                    cart
                  );


                var shareText =
                  buildShareText(
                    cart,
                    shareUrl
                  );


                var title =
                  'American Crane Shopping Cart';


                function openEmail() {

                  var mailto =

                    'mailto:' +

                    '?subject=' +

                    encodeURIComponent(
                      title
                    ) +

                    '&body=' +

                    encodeURIComponent(
                      shareText
                    );


                  window.location.href =
                    mailto;

                }


                if (
                  navigator.share
                ) {

                  navigator
                    .share({
                      title: title,
                      text: shareText,
                      url: shareUrl
                    })
                    .catch(
                      function (error) {

                        if (
                          error.name !==
                          'AbortError'
                        ) {

                          openEmail();

                        }

                      }
                    );

                } else {

                  openEmail();

                }

              }
            )

            .catch(
              function (error) {

                console.error(
                  'ACECO Share Cart Error:',
                  error
                );


                alert(
                  'We could not prepare the cart for sharing.'
                );

              }
            );

        }
      );

    }

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      setupAcecoCart
    );

  } else {

    setupAcecoCart();

  }

})();


  } catch(e) { console.error(e); }
})();
})();
